module.exports = __webpack_public_path__ + "img/201303152210276757.7f5105ba.jpg";